// import { useNavigate } from "react-router";
// import Navbar from "../../Components/Navbar/Navbar";
// import { FaUserTie } from "react-icons/fa6";
// import { FaIndianRupeeSign } from "react-icons/fa6";
// import { FaLanguage } from "react-icons/fa6";
// import { FaTractor } from "react-icons/fa";
// import { FaFileInvoiceDollar } from "react-icons/fa";
// import { AiFillPrinter } from "react-icons/ai";
// import { LiaFileInvoiceSolid } from "react-icons/lia";
// import { TbTax } from "react-icons/tb";
// import { useTranslation } from "react-i18next";
// import SecondLanguage from "../../Components/CommonComponent/Modals/SecondLanguage";
// import { FaBook } from "react-icons/fa";
// import { useState } from "react";
// import { useContext } from "react";
// import { CommonContext } from "../../App";
// import toast from "react-hot-toast";
// import { AiOutlineAudit } from "react-icons/ai";
// export default function WebSetting() {
//   const navigate=useNavigate();
//   const [secondLanguageModalOpen, setSecondLanguageModalOpen] = useState(false);
//   const [selectLanguage, setSelectLanguage] = useState('english');
//   const { branchId } = useContext(CommonContext);
//   // console.log("check brnach",branchId)
//   const {t}=useTranslation();
//   const settingsData = [
//   // {
//   //   title: t("users"),
//   //   icon: FaUserTie ,
//   //   path: "/web-setting/manager",
//   //   backgroudColor:"bg-white",
//   //   checkAllBranch: true,
//   // },
//   {
//     title: t("transportationArea"),
//     icon: FaTractor  ,
//     path: "/web-setting/area-table",
//     backgroudColor:"bg-white"
//   },
//   {
//     title: t("paymentAccount"),
//     icon: FaIndianRupeeSign ,
//     path: "/web-setting/payment-structure-table",
//     backgroudColor:"bg-white"
//   },
//   {
//     title: t("secondLanguage"),
//     icon: FaLanguage ,
//     // path: "/second-langugae",
//     isModal: true, 
//     backgroudColor:"bg-white"
//   },
//   // {
//   //   title: t("tax"),
//   //   icon: FaFileInvoiceDollar   ,
//   //   path: "/tax",
//   //   backgroudColor:"bg-white"
//   // },
//   // {
//   //   title: t("invoice"),
//   //   icon: LiaFileInvoiceSolid   ,
//   //   path: "/invioce",
//   //   backgroudColor:"bg-white"
//   // },
//   // {
//   //   title: t("printer"),
//   //   icon: AiFillPrinter  ,
//   //   path: "/printer",
//   //   backgroudColor:"bg-white"
//   // },
//   {
//     title: t("guideBook"),
//     icon: FaBook   ,
//     path: "/web-setting/guide-book",
//     backgroudColor:"bg-white"
//   },
//   // {
//   //   title: t("theftControl"),
//   //   icon: AiOutlineAudit     ,
//   //   path: "/web-setting/theft-controls",
//   //   backgroudColor:"bg-white"
//   // },
// ];
//   return (
//     <div className=""> 
//       {/* <Navbar/> */}


//     <div className="container-fluid">   
//       <div className="row py-2">
//         {settingsData.map((item, index) => {
//             const Icon = item.icon;

//             return (
//               <div key={index} className="col-2 p-2  xl:px-4 ">
//                 <div
//                   className="cursor-pointer"
//                    onClick={() => {
//                     if (item.isModal) {
//                       setSecondLanguageModalOpen(true); 
//                     } else {
//                         if (typeof branchId === "string" && branchId.includes(",") && !item.checkAllBranch) {
//                             toast.error(t("selectOnlyOneBranch"));
//                             return;
//                           } 
//                           navigate(item.path);
//                     }
//                   }}

//                 >
//                   <div className={`${item.backgroudColor} rounded border-1 border-theme-headerBg`}>
//                     <Icon className="h-24 text-theme-headerBg p-1 py-4 w-full" />
//                   </div>

//                   <div className="text-center text-sm font-medium mt-1">
//                     {item.title}
//                   </div>
//                 </div>
//               </div>
//             );
//           })} 

//          {/* <div className="col-1 p-2 px-4  " >
//               <div className="cursor-pointer" onClick={()=>navigate("/")}>
//                 <div className="bg-blue-100 rounded  " >
//                   <IoMdSettings className="h-16 p-1 w-full" />
//               </div>
//               <div className="text-center text-sm font-medium">
//                             Settings
//               </div>
//               </div>
//          </div> */}
//       </div>
//        </div>  
//        {secondLanguageModalOpen && (
//         <div className="fixed inset-0 bg-black/15 bg-opacity-50  flex justify-center items-center z-[9999]">
//         <SecondLanguage
//           isOpen={secondLanguageModalOpen}
//           onClose={() => setSecondLanguageModalOpen(false)}
//           onSave={(data) => setSelectLanguage(data.language)}
//         />

//         </div>
//       )}

//     </div>
//   )
// }


// import { useNavigate } from "react-router";
// import Navbar from "../../Components/Navbar/Navbar";
// import { FaUserTie } from "react-icons/fa6";
// import { FaIndianRupeeSign } from "react-icons/fa6";
// import { FaLanguage } from "react-icons/fa6";
// import { FaTractor } from "react-icons/fa";
// import { FaFileInvoiceDollar } from "react-icons/fa";
// import { AiFillPrinter } from "react-icons/ai";
// import { LiaFileInvoiceSolid } from "react-icons/lia";
// import { TbTax } from "react-icons/tb";
// import { useTranslation } from "react-i18next";
// import SecondLanguage from "../../Components/CommonComponent/Modals/SecondLanguage";
// import { FaBook } from "react-icons/fa";
// import { useState } from "react";
// import { useContext } from "react";
// import { CommonContext } from "../../App";
// import toast from "react-hot-toast";
// import { AiOutlineAudit } from "react-icons/ai";

// export default function WebSetting() {
//   const navigate = useNavigate();
//   const [secondLanguageModalOpen, setSecondLanguageModalOpen] = useState(false);
//   const [selectLanguage, setSelectLanguage] = useState("english");
//   const { branchId } = useContext(CommonContext);
//   const { t } = useTranslation();

//   const settingsData = [
//         {
//       title: t("guideBook"),
//       icon: FaBook,
//       path: "/web-setting/guide-book",
//       backgroudColor: "bg-white",
//       checkAllBranch: true, 
//     },
//         {
//       title: t("secondLanguage"),
//       icon: FaLanguage,
//       isModal: true,
//       backgroudColor: "bg-white",
//     },
//     {
//       title: t("transportationArea"),
//       icon: FaTractor,
//       path: "/web-setting/area-table",
//       backgroudColor: "bg-white",
//     },
//     {
//       title: t("paymentAccount"),
//       icon: FaIndianRupeeSign,
//       path: "/web-setting/payment-structure-table",
//       backgroudColor: "bg-white",
//     },
//   ];

//   return (
//     <div className="">
//       <div className="container-fluid">
//         <div className="row py-2">
//           {settingsData.map((item, index) => {
//             const Icon = item.icon;

//             return (
//               <div key={index} className="col-2 p-2 xl:px-4 ">
//                 <div
//                   className="cursor-pointer"
//                   onClick={() => {
//                     if (item.isModal) {
//                       setSecondLanguageModalOpen(true);
//                     } else {
//                       // ✅ Multiple branch check (Guide Book ko chhod kar)
//                       if (
//                         typeof branchId === "string" &&
//                         branchId.includes(",") &&
//                         !item.checkAllBranch
//                       ) {
//                         toast.error(t("selectOnlyOneBranch"));
//                         return;
//                       }
//                       navigate(item.path);
//                     }
//                   }}
//                 >
//                   <div
//                     className={`${item.backgroudColor} rounded border-1 border-theme-headerBg`}
//                   >
//                     <Icon className="h-24 text-theme-headerBg p-1 py-4 w-full" />
//                   </div>

//                   <div className="text-center text-sm font-medium mt-1">
//                     {item.title}
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       {secondLanguageModalOpen && (
//         <div className="fixed inset-0 bg-black/15 bg-opacity-50 flex justify-center items-center z-[9999]">
//           <SecondLanguage
//             isOpen={secondLanguageModalOpen}
//             onClose={() => setSecondLanguageModalOpen(false)}
//             onSave={(data) => setSelectLanguage(data.language)}
//           />
//         </div>
//       )}
//     </div>
//   );
// }

// ?????????????????????????????


// import { useNavigate } from "react-router";
// import { FaIndianRupeeSign } from "react-icons/fa6";
// import { FaLanguage } from "react-icons/fa6";
// import { FaTractor } from "react-icons/fa";
// import { MdTableRows } from "react-icons/md";
// import { useTranslation } from "react-i18next";
// import SecondLanguage from "../../Components/CommonComponent/Modals/SecondLanguage";
// import { FaBook } from "react-icons/fa";
// import { useState } from "react";
// import { useContext } from "react";
// import { CommonContext } from "../../App";
// import toast from "react-hot-toast";
// import TableFilterModal from "../../Components/CommonComponent/Modals/ShowTableFilterModal";
// import { MdOutlineFactCheck } from "react-icons/md";

// export default function WebSetting() {
//   const navigate = useNavigate();
//   const [secondLanguageModalOpen, setSecondLanguageModalOpen] = useState(false);
//   const [expenseFilterModalOpen, setExpenseFilterModalOpen] = useState(false);
//   const [selectLanguage, setSelectLanguage] = useState("english");
//   const { branchId } = useContext(CommonContext);
//   const { t } = useTranslation();

//   const settingsData = [
//     {
//       title: t("guideBook"),
//       icon: FaBook,
//       path: "/web-setting/guide-book",
//       backgroudColor: "bg-white",
//       checkAllBranch: true,
//     },
//     {
//       title: t("secondLanguage"),
//       icon: FaLanguage,
//       isModal: true,
//       modalKey: "secondLanguage",
//       backgroudColor: "bg-white",
//     },
//     {
//       title: t("Transportation&LoadingExpenseSettings"),
//       icon: MdOutlineFactCheck ,
//       isModal: true,
//       modalKey: "expenseFilter",
//       backgroudColor: "bg-white",
//     },
//     {
//       title: t("transportationArea"),
//       icon: FaTractor,
//       path: "/web-setting/area-table",
//       backgroudColor: "bg-white",
//     },
//     {
//       title: t("paymentAccount"),
//       icon: FaIndianRupeeSign,
//       path: "/web-setting/payment-structure-table",
//       backgroudColor: "bg-white",
//     },
//   ];

//   const handleCardClick = (item) => {
//     if (item.isModal) {
//       if (item.modalKey === "secondLanguage") setSecondLanguageModalOpen(true);
//       else if (item.modalKey === "expenseFilter") setExpenseFilterModalOpen(true);
//       return;
//     }
//     if (typeof branchId === "string" && branchId.includes(",") && !item.checkAllBranch) {
//       toast.error(t("selectOnlyOneBranch"));
//       return;
//     }
//     navigate(item.path);
//   };

//   return (
//     <div className="">
//       <div className="container-fluid">
//         <div className="row py-2">
//           {settingsData.map((item, index) => {
//             const Icon = item.icon;
//             return (
//               <div key={index} className="col-2 p-2 xl:px-4">
//                 <div className="cursor-pointer" onClick={() => handleCardClick(item)}>
//                   <div className={`${item.backgroudColor} rounded border-1 border-theme-headerBg`}>
//                     <Icon className="h-24 text-theme-headerBg p-1 py-4 w-full" />
//                   </div>
//                   <div className="text-center text-sm font-medium mt-1">{item.title}</div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       {secondLanguageModalOpen && (
//         <div className="fixed inset-0 bg-black/15 bg-opacity-50 flex justify-center items-center z-[9999]">
//           <SecondLanguage
//             isOpen={secondLanguageModalOpen}
//             onClose={() => setSecondLanguageModalOpen(false)}
//             onSave={(data) => setSelectLanguage(data.language)}
//           />
//         </div>
//       )}

//       {expenseFilterModalOpen && (
//         <TableFilterModal
//           isOpen={expenseFilterModalOpen}
//           onClose={() => setExpenseFilterModalOpen(false)}
//         />
//       )}
//     </div>
//   );
// }

import { useNavigate } from "react-router";
import { FaIndianRupeeSign } from "react-icons/fa6";
import { FaLanguage } from "react-icons/fa6";
import { FaTractor } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import SecondLanguage from "../../Components/CommonComponent/Modals/SecondLanguage";
import { FaBook } from "react-icons/fa";
import { useState, useContext } from "react";
import { CommonContext } from "../../App";
import toast from "react-hot-toast";
import TableFilterModal from "../../Components/CommonComponent/Modals/ShowTableFilterModal";
import { MdOutlineFactCheck } from "react-icons/md";
import { FaEllipsisV } from "react-icons/fa";
import { FaUserTie } from "react-icons/fa6";
import { useMemo } from "react";

export default function WebSetting() {
  const navigate = useNavigate();
  const [secondLanguageModalOpen, setSecondLanguageModalOpen] = useState(false);
  const [expenseFilterModalOpen, setExpenseFilterModalOpen] = useState(false);
  const [moreOptionsModalOpen, setMoreOptionsModalOpen] = useState(false);
  const [selectLanguage, setSelectLanguage] = useState("english");
  const { branchId ,userData} = useContext(CommonContext);
  const { t } = useTranslation();
  const [journalEntrySettings, setJournalEntrySettings] = useState(() => {
    const saved = localStorage.getItem("moreOptionsSettings");
    return saved
      ? JSON.parse(saved)
      : { JournalEntry: false };
  });

  const handleCardClick = (item) => {
    if (item.isModal) {
      if (item.modalKey === "secondLanguage")
        setSecondLanguageModalOpen(true);
      else if (item.modalKey === "expenseFilter")
        setExpenseFilterModalOpen(true);
      else if (item.modalKey === "moreOptions")
        setMoreOptionsModalOpen(true);
      return;
    }

    if (
      typeof branchId === "string" &&
      branchId.includes(",") &&
      !item.checkAllBranch
    ) {
      toast.error(t("selectOnlyOneBranch"));
      return;
    }

    navigate(item.path);
  };
      const rights = useMemo(() => {
      try {
        if (!userData?.user?.rights || userData?.user?.rights === "undefined") {
          return [];
        }
  
        // Agar already array ho
        if (Array.isArray(userData?.user?.rights)) {
          return userData?.user?.rights;
        }
  
        return JSON.parse(userData?.user?.rights);
      } catch (error) {
        console.error("Invalid rights format:", userData?.rights);
        return [];
      }
    }, [userData]);
  
  
    const hasRight = (right) => {
      return rights.includes(right);
    };

  const saveJournalEntrySettings = (key, value) => {
    setJournalEntrySettings((prev) => {
      const newSettings = { ...prev, [key]: value };
      localStorage.setItem(
        "moreOptionsSettings",
        JSON.stringify(newSettings)
      );
      return newSettings;
    });
  };
  

  const settingsData = [
    {
      title: t("guideBook"),
      icon: FaBook,
      path: "/web-setting/guide-book",
      backgroudColor: "bg-white",
      checkAllBranch: true,
    },
    {
      title: t("secondLanguage"),
      icon: FaLanguage,
      isModal: true,
      modalKey: "secondLanguage",
      backgroudColor: "bg-white",
    },
    {
      title: t("Transportation&LoadingExpenseSettings"),
      icon: MdOutlineFactCheck,
      isModal: true,
      modalKey: "expenseFilter",
      backgroudColor: "bg-white",
    },
    {
      title: t("transportationArea"),
      icon: FaTractor,
      path: "/web-setting/area-table",
      backgroudColor: "bg-white",
    },
    {
      title: t("paymentAccount"),
      icon: FaIndianRupeeSign,
      path: "/web-setting/payment-structure-table",
      backgroudColor: "bg-white",
    },
    {
      title: t("moreOptions"),
      icon: FaEllipsisV,
      isModal: true,
      modalKey: "moreOptions",
      backgroudColor: "bg-white",
    },
  ];
  if (userData.user.role === "admin" || hasRight("create_manager")) {
  settingsData.push({
    title: t("users"),
    icon: FaUserTie,
    path: "/web-setting/manager",
    backgroudColor: "bg-white",
    checkAllBranch: true,
  });
}


  return (
    <div>
      <div className="container-fluid">
        <div className="row py-2">
          {settingsData.map((item, index) => {
            const Icon = item.icon;
            return (
              <div key={index} className="col-2 p-2 xl:px-4">
                <div
                  className="cursor-pointer"
                  onClick={() => handleCardClick(item)}
                >
                  <div
                    className={`${item.backgroudColor} rounded border-1 border-theme-headerBg`}
                  >
                    <Icon className="h-24 text-theme-headerBg p-1 py-4 w-full" />
                  </div>
                  <div className="text-center text-sm font-medium mt-1">
                    {item.title}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Second Language Modal */}
      {secondLanguageModalOpen && (
        <div className="fixed inset-0 bg-black/15 flex justify-center items-center z-[9999]">
          <SecondLanguage
            isOpen={secondLanguageModalOpen}
            onClose={() => setSecondLanguageModalOpen(false)}
             onSave={(data) => setSelectLanguage(data.language)}
          />
        </div>
      )}

      {/* Expense Filter Modal */}
      {expenseFilterModalOpen && (
        <TableFilterModal
          isOpen={expenseFilterModalOpen}
          onClose={() => setExpenseFilterModalOpen(false)}
        />
      )}

      {/* Overlay */}
      <div
        onClick={() => setMoreOptionsModalOpen(false)}
        className={`fixed inset-0 bg-black/30 z-[9998] transition-opacity duration-300 ${
          moreOptionsModalOpen
            ? "opacity-100 visible"
            : "opacity-0 invisible"
        }`}
      />

      {/* Smooth Right Offcanvas */}
      <div
        className={`fixed right-0 top-0 h-full w-96 bg-white shadow-2xl z-[9999]
        transform transition-transform duration-300 ease-in-out
        ${moreOptionsModalOpen ? "translate-x-0" : "translate-x-full"}`}
      >
        <div className="p-1 px-2 border-b border-gray-200 relative">
     <div className="flex justify-between">
       <div>
           <div className=" font-semibold text-theme-headerBg ">
            {t("moreOptions")}
          </div>
       </div>
        <div >
            <button
            onClick={() => setMoreOptionsModalOpen(false)}
            className=" text-gray-700 text-xl font-bold hover:text-gray-900"
          >
            &times;
          </button>
        </div>
         
     </div>
        </div>

        <div className="p-2 space-y-2 overflow-y-auto h-[calc(100%-80px)]">
          {/* Toggle Item */}
          {[
            {
              key: "JournalEntry",
              title: t("JournalEntry"),
              desc: t("itemsManageStockQuantityOption"),
            },
            // {
            //   key: "showManageStock",
            //   title: "Manage Stock",
            //   desc: "Enable stock management",
            // },
            // {
            //   key: "showQuantity",
            //   title: "Quantity in Journal",
            //   desc: "Show quantity fields",
            // },
          ].map((item) => (
            <div
              key={item.key}
              className="flex justify-between gap-3 items-center p-2 bg-theme-tableHoverColor rounded"
            >
              <div>
                <div className="font-medium text-sm text-theme-sidebarBg">{item.title}</div>
                <div className="text-xs text-gray-500">{item.desc}</div>
              </div>

              <label className="relative inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={journalEntrySettings[item.key]}
                  onChange={(e) =>
                    saveJournalEntrySettings(
                      item.key,
                      e.target.checked
                    )
                  }
                />
                <div className="w-11 h-6 bg-gray-400 rounded-full peer peer-checked:bg-theme-headerBg transition-all"></div>
                <div className="absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-all peer-checked:translate-x-5"></div>
              </label>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}